declare const Swiper: any;

export default function useCategoryFilter() {
  function loadExternalResources(callback: () => void) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.css";
    document.head.appendChild(link);

    const script = document.createElement("script");
    script.src = "https://cdn.jsdelivr.net/npm/swiper@10/swiper-bundle.min.js";
    script.onload = callback;
    document.body.appendChild(script);
  }

  function setupInstallmentPlans() {
    const style = document.createElement("style");
    style.textContent = `
      .select-all.pt_none { opacity: 0; height: 10px; z-index: -1; margin: 0; }
      .listing-content .listing-collections.none_listing { display: none; }
      .listing-collections-custom { margin-top: 45px; padding: 15px 0; }
      .listing-collections-custom .swiper-container { overflow: hidden; }
      .listing-collections-custom .swiper-slide { display: flex; align-items: center; justify-content: center; }
      .listing-collections-custom .swiper-pagination { display: none; }
      @media (max-width: 767.98px) {
        .listing-collections-custom .swiper-pagination { display: block; }
      }
    `;
    document.head.appendChild(style);

    function noneListingContent() {
      document.querySelector(".listing-page .listing-content > .listing-collections")?.classList.add("none_listing");
    }

    function generateCartItems() {
      const cartItemsHTML: string[] = [];
      let shouldRender = false;
      document.querySelectorAll(".filter-section").forEach((section) => {
        const titleElement = section.querySelector(".filter-section-title");
        if (!titleElement) return;
        if (titleElement.textContent.trim() === "Collection") {
          shouldRender = true;
          let hasActive = false;
          const subItemsHTML: string[] = [];

          section.querySelector(".filter-section-content .select-all")?.classList.add("pt_none");
    
          section.querySelectorAll(".filter-section-content label").forEach((label) => {
            const input = label.querySelector("input[type='checkbox']") as HTMLInputElement | null;
            if (!input) return;
    
            const className = Array.from(input.classList).filter((c) => c !== "filter-checkbox").join(" ");
            const isActive = input.checked ? "isactive" : ""; 
            if (input.checked) {
              hasActive = true;
            }
    
            subItemsHTML.push(`<div class="cart-item swiper-slide ${className} ${isActive}">
              <label for="cat-${className}">
                <input id="cat-${className}" type="checkbox" name="category[]" value="${className}" ${input.checked ? "checked" : ""}>
                <span>${label.textContent?.trim()}</span>
              </label>
            </div>`);
          });

          const allIsActive = !hasActive ? "isactive" : "";
          const allChecked = !hasActive ? "checked" : "";
          cartItemsHTML.push(`
            <div class="cart-item swiper-slide all-item ${allIsActive}">
              <label for="cat-all">
                <input id="cat-all" type="checkbox" name="category[]" value="all" ${allChecked}>
                <span>All</span>
              </label>
            </div>
          `);

          cartItemsHTML.push(...subItemsHTML);
        }
      });
      
    if (!shouldRender || cartItemsHTML.length === 0) return;
      const container = document.createElement("div");
      container.classList.add("listing-collections-custom");
      container.innerHTML = `<div class="box-cat-filter swiper swiper-free-mode"><div class="swiper-wrapper">${cartItemsHTML.join("")}</div></div>`;
    
      const parent = document.querySelector(".listing-page .listing-content");
      const target = document.querySelector(".listing-page .listing-collections");
    
      if (target) {
        target.insertAdjacentElement("afterend", container);
      } else if (parent) {
        parent.prepend(container);
      }
    }

    function initSwiper() {
      const swiperContainer = document.querySelector(".box-cat-filter.swiper");
      
      if (!swiperContainer) {
        console.error("Swiper container not found!");
        return;
      }
      let last_index = 0;
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: "auto",
        spaceBetween: 10,
        arrows: false,
        pagination: false,
        drag: "free",
        mediaQuery: "max",
        autoWidth: true,
        breakpoints: {
          768: {
            slidesPerView: 4,
            spaceBetween: 15,
          },
          1024: {
            slidesPerView: 6,
            spaceBetween: 20,
          },
        },
        on: {
          slideChange: updateProgressBar,
          sliderMove: updateProgressBar,
        },
      });
      const progressBarContainer = document.createElement("div");
        progressBarContainer.classList.add("my-slider-progress", "is-active");
        
        const progressBar = document.createElement("div");
        progressBar.classList.add("my-slider-progress-bar");
        progressBar.style.width = "0%";
        
        progressBarContainer.appendChild(progressBar);
        swiperContainer.insertAdjacentElement("afterend", progressBarContainer);
        updateProgressBar();
        function updateProgressBar() {
          const totalSlides = swiper.slides.length;
          const currentSlide = swiper.realIndex + 1;
          last_index = currentSlide;
          
          if (swiper.isEnd) {
            progressBar.style.width = "100%";
          }else{
            const progress = (currentSlide / totalSlides) * 100;
            progressBar.style.width = `${progress}%`;
          }
        }

    }

    function setupEventHandlers() {
      document.addEventListener("click", (event) => {
        const target = event.target as HTMLElement;

        if (target.closest(".clear-filter-checkbox")) {
          document.querySelectorAll(".listing-collections-custom .cart-item input[type='checkbox']").forEach((checkbox) => {
            (checkbox as HTMLInputElement).checked = false;
          });
          document.querySelectorAll(".listing-collections-custom .cart-item").forEach((classItem) => {
            classItem.classList.remove("isactive");
          });
          const allItems = document.querySelector(".listing-collections-custom .cart-item.all-item");
          if (allItems) {
            allItems.classList.add("isactive");
            const allCheckbox = allItems.querySelector("input[type='checkbox']") as HTMLInputElement | null;
            if (allCheckbox) allCheckbox.checked = true;
          }
          return;
        }
       
        if (target.closest(".listing-collections-custom .cart-item.all-item.isactive")) {
          return;
        }
        if (target.matches(".listing-collections-custom .cart-item input[type='checkbox']")) {
          const input = event.target as HTMLInputElement;
          const value = input.value;
          const allItems = document.querySelector(".listing-collections-custom .cart-item.all-item");
      
          if (input.closest(".listing-collections-custom .cart-item")?.classList.contains("all-item")) {
            document.querySelectorAll(".listing-collections-custom .cart-item").forEach((item) => {
              if (!item.classList.contains("all-item")) {
                item.classList.remove("isactive");
                const cb = item.querySelector("input[type='checkbox']") as HTMLInputElement | null;
                if (cb) cb.checked = false;
              } else {
                item.classList.add("isactive");
                const cb = item.querySelector("input[type='checkbox']") as HTMLInputElement | null;
                if (cb) cb.checked = true;
              }
            });
    
            document
              .querySelectorAll(".filter-menu .filter-content .filter-body .filter-section")
              .forEach((section) => {
                const titleElement = section.querySelector(".filter-section-title");
                if (titleElement && titleElement.textContent.trim() === "Collection") {
                  section.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                    (checkbox as HTMLInputElement).checked = false;
                    checkbox.dispatchEvent(new Event("change"));
                  });
                }
              });
    
            return;
          }
      
          const clickedItem = input.closest(".listing-collections-custom .cart-item");
          if (!clickedItem) return;

          if (clickedItem.classList.contains("isactive")) {
            clickedItem.classList.remove("isactive");
            input.checked = false;
          } else {
            document.querySelectorAll(".listing-collections-custom .cart-item").forEach((item) => {
              item.classList.remove("isactive");
              const cb = item.querySelector("input[type='checkbox']") as HTMLInputElement | null;
              if (cb) cb.checked = false;
            });
            clickedItem.classList.add("isactive");
            input.checked = true;
          }

          const hasActiveSub = document.querySelectorAll(".listing-collections-custom .cart-item:not(.all-item).isactive").length > 0;
          if (!hasActiveSub && allItems) {
            allItems.classList.add("isactive");
            const allCheckbox = allItems.querySelector("input[type='checkbox']") as HTMLInputElement | null;
            if (allCheckbox) allCheckbox.checked = true;
          } else if (allItems) {
            allItems.classList.remove("isactive");
            const allCheckbox = allItems.querySelector("input[type='checkbox']") as HTMLInputElement | null;
            if (allCheckbox) allCheckbox.checked = false;
          }
      
          document
            .querySelectorAll(".filter-menu .filter-content .filter-body .filter-section")
            .forEach((section) => {
              const titleElement = section.querySelector(".filter-section-title");
              if (titleElement && titleElement.textContent.trim() === "Collection") {
                
                section.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                  (checkbox as HTMLInputElement).checked = false;
                  checkbox.dispatchEvent(new Event("change"));
                });
      
                const targetInput = Array.from(section.querySelectorAll("input[type='checkbox']")).find(el => 
                  el.classList.contains(value)
                ) as HTMLInputElement | undefined;

                if (targetInput) {
                  targetInput.checked = input.checked;
                  targetInput.dispatchEvent(new Event("change"));
                }
              }
            });
        }
      
        if (target && target.matches(".filter-menu .filter-content .filter-body .filter-section input[type='checkbox']")) {
          const input = target as HTMLInputElement;
          
          const section = input.closest(".filter-section");
          const titleElement = section?.querySelector(".filter-section-title");
        
          if (titleElement && titleElement.textContent.trim() === "Collection") {
            const value = input.classList.contains("filter-checkbox")
              ? input.className.replace("filter-checkbox", "").trim()
              : '';
           
        
            document.querySelectorAll(".filter-menu .filter-content .filter-body .filter-section").forEach((otherSection) => {
              const otherTitleElement = otherSection.querySelector(".filter-section-title");
              if (otherTitleElement && otherTitleElement.textContent.trim() === "Collection") {
                otherSection.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
                  if (checkbox !== input) {
                    (checkbox as HTMLInputElement).checked = false;
                    checkbox.dispatchEvent(new Event("change"));
                  }
                });
              }
            });
        
            document.querySelectorAll(".listing-collections-custom .cart-item input[type='checkbox']").forEach((checkbox) => {
              (checkbox as HTMLInputElement).checked = false;
            });
            document.querySelectorAll(".listing-collections-custom .cart-item").forEach((classItem) => {
              classItem.classList.remove("isactive");
            });
            
            const allItems = document.querySelector(".listing-collections-custom .cart-item.all-item");
            if (value && input.checked) {
              const targetCartInput = Array.from(document.querySelectorAll(".listing-collections-custom .cart-item")).find(cartItem => 
                cartItem.classList.contains(value)
              );
              if (targetCartInput) {
                const inputCheckbox = targetCartInput.querySelector("input[type='checkbox']") as HTMLInputElement | null;
                if (inputCheckbox) inputCheckbox.checked = input.checked;
                if (input.checked) {
                    targetCartInput.classList.add("isactive");
                } else {
                    targetCartInput.classList.remove("isactive");
                }
              }
              if (allItems) {
                allItems.classList.remove("isactive");
                const allCheckbox = allItems.querySelector("input[type='checkbox']") as HTMLInputElement | null;
                if (allCheckbox) allCheckbox.checked = false;
              }
            } else if (allItems) {
              allItems.classList.add("isactive");
              const allCheckbox = allItems.querySelector("input[type='checkbox']") as HTMLInputElement | null;
              if (allCheckbox) allCheckbox.checked = true;
            }
          }
        }
        
      });
    }

    noneListingContent();
    generateCartItems();
    setupEventHandlers();
    setTimeout(initSwiper, 500);
  }

  if (process.client && (window.location.pathname.startsWith("/product-category/") || window.location.pathname.startsWith("/ms-my/product-category/"))) {
    loadExternalResources(setupInstallmentPlans);
  }
}
